import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import PaystackPop from "@paystack/inline-js";
import Swal from "sweetalert2";
import axios from "axios";
import { Context } from './Context';

// --- Styled Components ---

const PaymentContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
//   padding: 2rem 1rem;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  min-height: 100vh;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
`;

const PaymentCard = styled.div`
  background: #ffffff;
  width: 100%;
  max-width: 500px;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  padding: 2.5rem;
  border: 1px solid #e2e8f0;
`;

const Title = styled.h2`
  font-size: 1.5rem;
  color: #0f172a;
//   margin: 0 0 0.5rem 0;
  font-weight: 700;
  text-align: center;
  word-break: break-word;
`;

const Subtitle = styled.p`
  font-size: 0.95rem;
  color: #64748b;
  margin: 0 0 0.5rem 0;
  text-align: center;
  word-break: break-word;
`;

const CardLogosContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
//   gap: 1rem;
  margin-bottom: 0.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f5f9;

  img {
    height: 32px;
    object-fit: contain;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.05));
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
//   gap: 0.5rem;

  label {
    font-size: 0.85rem;
    font-weight: 600;
    color: #334155;
    word-break: break-word;
  }

  input, select {
    padding: 0.85rem 1rem;
    border: 1px solid #cbd5e1;
    border-radius: 10px;
    font-size: 0.95rem;
    color: #0f172a;
    outline: none;
    transition: all 0.2s ease;
    background: #f8fafc;

    &:focus {
      border-color: #3b82f6;
      background: #ffffff;
      box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
    }
  }
`;

const SummaryBox = styled.div`
  background: #f1f5f9;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 0.5rem;

  span {
    font-size: 0.9rem;
    color: #475569;
    font-weight: 600;
  }

  strong {
    font-size: 1.25rem;
    color: #0f172a;
    font-weight: 800;
  }
`;

const PayButton = styled.button`
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: #ffffff;
  border: none;
  border-radius: 12px;
  padding: 1rem;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
  margin-top: 1rem;
  word-break: break-word;

  &:hover {
    background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(37, 99, 235, 0.35);
  }

  &:active {
    transform: translateY(0);
  }
`;

// --- Component ---

export default function KidsCodePaystackCardPayment() {
  const [deliveryDetails, setDeliveryDetails] = useState({
    name: '',
    email: '',
    childrenCount: '1'
  });

  const {confirmPaymentUrl} = useContext(Context)// Replace with your actual backend endpoint URL

  // Calculate total: N50,000 for 1 child, N45,000 per child if more than one
  const calculateTotal = () => {
    const count = parseInt(deliveryDetails.childrenCount, 10) || 1;
    if (count > 1) {
      return count * 45000;
    }
    return 50000;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDeliveryDetails((prev) => ({ ...prev, [name]: value }));
  };

  const postOrderFunction = (reference) => {
    console.log("Order posted for reference:", reference);
    // Add your custom order posting logic here
  };

  const sendOrderEmailFunction = (reference) => {
    console.log("Email sent for reference:", reference);
    // Add your custom email dispatch logic here
  };

  const payWithPaystack = (e) => {
    e.preventDefault();

    if (!deliveryDetails.name || !deliveryDetails.email) {
      Swal.fire({ icon: "warning", text: "Please fill in your name and email.", showConfirmButton: true });
      return;
    }

    const paystack = new PaystackPop();
    paystack.newTransaction({
        //   key: "pk_test_60e1f53bba7c80b60029bf611a26a66a9a22d4e4",
      key: "pk_live_3626fe7772aaca28a10724ebb1f9727dfcc5d6cb",
      amount: calculateTotal() * 100,
      email: deliveryDetails.email,
      firstname: deliveryDetails.name,
      channels: ['card'], // Restrict payment channels to Card only
      onSuccess: (transaction) => {
        // verifyTransaction(transaction.reference);
            Swal.fire({
          icon: "success",
          text: "Payment successful!",
          showConfirmButton: true,
        });

        setDeliveryDetails({
    name: '',
    email: '',
    childrenCount: '1'
  });
      },
      onCancel: () => {
        Swal.fire({ icon: "error", text: "Payment cancelled.", showConfirmButton: true });
      },
      onError: (error) => {
        Swal.fire({ icon: "error", text: `Payment failed: ${error.message}`, showConfirmButton: true });
      }
    });
  };

// const verifyTransaction = async (reference) => {
//     const loadingAlert = Swal.fire({
//       title: "Confirming payment",
//       text: "Please wait...",
//       allowOutsideClick: false,
//       allowEscapeKey: false,
//       showConfirmButton: false
//     });

//     Swal.showLoading();

//     try {
//       const response = await axios.post(`${confirmPaymentUrl}`, { reference });

//       if (response.data.status === 'success') {
//         Swal.fire({
//           icon: "success",
//           text: "Payment successful!",
//           showConfirmButton: true,
//           timer: 2000
//         });

//         postOrderFunction(reference);
//         sendOrderEmailFunction(reference);
//       } else {
//         Swal.fire({
//           icon: "error",
//           text: `${response.data.message || "Payment verification failed."}`,
//           showConfirmButton: true
//         });
//       }
//     } catch (error) {
//       // Production-ready error handling
//       Swal.fire({
//         icon: "error",
//         text: error.response?.data?.message || 'Error connecting to server to verify payment!',
//         showConfirmButton: true
//       });
//     } finally {
//       loadingAlert.close();
//     }
//   };

  const totalAmount = calculateTotal();

  return (
    <PaymentContainer>
      <PaymentCard>
        <Title>Online Payment</Title>
        <Subtitle>Secure card payment for your online class batch</Subtitle>

        {/* Master Card & Visa Card Logos */}
        <CardLogosContainer>
          <img 
            src="https://upload.wikimedia.org/wikipedia/commons/2/2a/Mastercard-logo.svg" 
            alt="Mastercard" 
          />
          {/* <img 
            src="https://upload.wikimedia.org/wikipedia/commons/5/5e/Visa_Inc._logo.svg" 
            alt="Visa" 
          /> */}
        </CardLogosContainer>

        <Form onSubmit={payWithPaystack}>

      

          <FormGroup>
            <label htmlFor="name">Full Name</label>
            <input 
              type="text" 
              id="name" 
              name="name" 
              placeholder="Enter your full name" 
              value={deliveryDetails.name}
              onChange={handleInputChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <label htmlFor="email">Email Address</label>
            <input 
              type="email5" 
              type="email"
              id="email" 
              name="email" 
              placeholder="Enter your email address" 
              value={deliveryDetails.email}
              onChange={handleInputChange}
              required
            />
          </FormGroup>

          <FormGroup>
            <label htmlFor="childrenCount">Number of Children</label>
            <select 
              id="childrenCount" 
              name="childrenCount" 
              value={deliveryDetails.childrenCount}
              onChange={handleInputChange}
            >
              <option value="1">1 Child (N50,000)</option>
              <option value="2">2 Children (N45,000 / child)</option>
              <option value="3">3 Children (N45,000 / child)</option>
              <option value="4">4 Children (N45,000 / child)</option>
            </select>
          </FormGroup>

          <SummaryBox>
            <span>Total Amount:</span>
            <strong>N{totalAmount.toLocaleString()}</strong>
          </SummaryBox>

          <PayButton type="submit">
            Pay N{totalAmount.toLocaleString()} 
          </PayButton>
        </Form>
      </PaymentCard>
    </PaymentContainer>
  );
}